import { SCANNER_DATA, JOB_DATA, CLEAR_JOB_DATA } from "./type";

export const cachingScannerData = (payload) => ({
    type: SCANNER_DATA,
    payload,
});

export const cachingJobData = (payload) => ({
    type: JOB_DATA,
    payload,
});

export const clearCachingData = (payload) => ({
    type: CLEAR_JOB_DATA,
    payload,
});